import { createContext } from 'react';
import { PaywallPopupReason } from '@nx-frontend/shared/types';
import { BillingPlanCodeWithoutPeriod, PaywallMode } from '@nx-frontend/shared/types/paywall-types';
import { PaywallActionDiscounts } from './action-discounts';

interface PaywallContextValue {
  mode: PaywallMode;
  showOrderSummary: boolean;
  isFreePlan: boolean;
  title?: string;
  paywallAdditionPaymentParams: Record<string, string>;
  reason: PaywallPopupReason;
  isAppsumo: boolean;
  showFreeTrial?: boolean;
  action: PaywallActionDiscounts | null;
  onClose: () => void;
  subscriptionType?: BillingPlanCodeWithoutPeriod;
  getTimeDelta: () => number;
}

export const PaywallContext = createContext<PaywallContextValue>({
  mode: 'trialStart',
  title: '',
  showOrderSummary: false,
  isFreePlan: false,
  paywallAdditionPaymentParams: {},
  reason: PaywallPopupReason.BOTTOM_MENU_UPGRADE,
  isAppsumo: false,
  showFreeTrial: false,
  action: null,
  onClose: () => {
    return;
  },
  subscriptionType: undefined,
  getTimeDelta: () => 0,
});
